import React, { useState, useEffect } from 'react';
import {
  Container,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  DialogActions
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import { getUser } from 'src/utils/Common';
import {
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials
} from '../../store/actions';
import AtananIsler from './AssignedJob';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(3)
  },
  statistics: {
    marginTop: theme.spacing(3)
  },
  AtananIsler: {
    marginTop: theme.spacing(1)
  },
  projects: {
    marginTop: theme.spacing(6)
  },
  todos: {
    marginTop: theme.spacing(6)
  },
  content: {
    padding: 0,
    minHeight: 430
  }
}));

const Overview = props => {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const SessionUser = getUser();
  var TitleApp = "Sirius Partner";
  const {
    getTasksRequest,
    resetDefects,
    resetLabours,
    resetMaterials,
    tasks
  } = props;

  const AtananIslerData = tasks.tasks;

  const handleRefresh = () => {
    getTasksRequest();
    resetLabours();
    resetDefects();
    resetMaterials();
  };

  // useState ve useEffect kullanımı
  const [isPopupDisplayed, setPopupDisplayed] = useState(true);

  useEffect(() => {
    const popUpControl = sessionStorage.getItem('InformationPopup');
    setPopupDisplayed(popUpControl === "1" ? false : true);
  }, []); // boş bağımlılık dizisi, yalnızca ilk render sırasında çalışmasını sağlar

  const handleClose = () => {
    setPopupDisplayed(false);
    sessionStorage.setItem("InformationPopup", "1");
  };

  return (
    <Page className={classes.root} title={TitleApp}>
      <Container maxWidth="xl">
        <AtananIsler
          className={classes.AtananIsler}
          AtananIsler={AtananIslerData}
          handleRefresh={handleRefresh}
        />
      </Container>
      <Dialog
         open={isPopupDisplayed}
         fullWidth
         maxWidth="sm"
         onClose={() => handleClose(false)}
         aria-labelledby="alert-dialog-title"
         aria-describedby="alert-dialog-description"
       >
         <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('lblmportantReminder')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
          {t('lblInformationText')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
       </Dialog>
    </Page>
  );
};

export default connect(state => ({ tasks: state.tasks1 }), {
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials
})(Overview);
